export default __webpack_public_path__ + "static/media/cog-wheel-silhouette.3832aadf.svg";